import { Col, Form, Input, Label, Modal, ModalBody, Row } from "reactstrap";
import { Btn, H4 } from "../../../../AbstractElements";
import { Cancel, CreateTag, Save, TagColor, TagName } from "../../../../Constants/Constants";
import { useAppDispatch, useAppSelector } from "../../../../ReduxToolkit/Hooks";
import { setTagModal } from "../../../../ReduxToolkit/Reducers/BookmarkTabSlice";

const ModalTag = () => {
  const { tagModal } = useAppSelector((state) => state.bookmarkTab);
  const dispatch = useAppDispatch();
  const tagToggle = () => dispatch(setTagModal());

  return (
    <Modal className="modal-bookmark" size="lg" isOpen={tagModal} toggle={tagToggle}>
      <div className="modal-header">
        <H4 className="modal-title">{CreateTag}</H4>
        <Btn close color="transparent" onClick={tagToggle}></Btn>
      </div>
      <ModalBody>
        <Form className="form-bookmark needs-validation">
          <Row className="g-2">
            <Col md="12" className="mb-3 mt-0">
              <Label>{TagName}</Label>
              <Input type="text" />
            </Col>
            <Col md="12" className="mb-3 mt-0">
              <Label>{TagColor}</Label>
              <input type="color" className="d-block form-color" defaultValue="#2A5699" />
            </Col>
          </Row>
          <Btn color="secondary" className="me-1" onClick={tagToggle}>{Save}</Btn>
          <Btn color="primary" onClick={tagToggle}>{Cancel}</Btn>
        </Form>
      </ModalBody>
    </Modal>
  );
};
export default ModalTag;
